

import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { getBrowserName, isLoggedIn } from "config/utils";

// __________ paytm payment api  __________
export const scanQrCode = async (data = {}) => {
  const token = isLoggedIn();
  return decryptData(
    await axios.post(`/scan-qr-code`, {
      reqData: encryptData({
        ...data,
                platformType: getBrowserName(),
        access_token: token,
      
      }),
    })
  );
};